module.exports = __webpack_public_path__ + "img/app-lld.06ef465c.png";